"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = require("lodash");

var _ = require(".");

var _usePrevious = _interopRequireDefault(require("./util/usePrevious"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    if (i % 2) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(arguments[i]));
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} // Generated by CoffeeScript 2.3.2


var addPropsOnChange;

addPropsOnChange = function addPropsOnChange(didChange, getProps) {
  var prevAddedProps;

  if ((0, _lodash.isArray)(didChange)) {
    return (0, _.addProps)(getProps, didChange);
  }

  prevAddedProps = null;
  return function (props) {
    var addedProps, changed, prevProps;
    prevProps = (0, _usePrevious["default"])(props);
    changed = !prevAddedProps || prevProps == null || didChange(prevProps, props);
    addedProps = changed ? getProps(props) : prevAddedProps;
    prevAddedProps = addedProps;
    return _objectSpread({}, props, {}, addedProps);
  };
};

var _default = addPropsOnChange;
exports["default"] = _default;